<template>
  <h2 class="gradation">SNSでログイン</h2>

  <div class="d-flex justify-center mb-4">
    <button class="sns-login line" @click="loginLine">
      <img src="/images/sns/LINE_APP_Android.png" alt="line icon" width="60" />
    </button>
    <button class="sns-login facebook" @click="loginFacebook">
      <img src="/images/sns/i_facebook.png" alt="facebook icon" />
    </button>
    <button class="sns-login yahoo" @click="loginYahoo">
      <img src="/images/sns/i_yahoo.png" alt="Yahoo! JAPAN icon" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'SnsLogin',
  components: {},
  data: () => ({}),
  mounted() { },
  methods: {
    loginLine() {
      window.location.href = '/sns/login?channel=line&action=login&pwa=true';
    },
    loginFacebook() {
      window.location.href = '/sns/login?channel=facebook&action=login';
    },
    loginYahoo() {
      window.location.href = '/sns/login?channel=yahoo&action=login';
    }
  }
}
</script>

<style>
.sns-login {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: auto;
  color: #fff;
  margin: 0 20px;
}

.sns-login.facebook {
  background-color: #3b5998;
}

.sns-login.yahoo {
  background-color: #ff0033;
}

.sns-login.facebook img,
.sns-login.yahoo img {
  width: 60%;
}</style>